import Grid from "components/grid";
import ListHead from "components/subHead/listHead";
import { useTranslation } from "react-i18next";
import useModalStore from "store/modal";
import { useSearchList } from "./service";
import { detail } from "./handles";
import RoomCancelResvDetail from "./detail";

export default function RoomCancelResvList() {
  const { t } = useTranslation();
  const { rowData, pageNav } = useSearchList();
  const onSetModal = useModalStore((state) => state.onSetModal);

  const theads = [
    ...prevTheads,
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 80,
      styles: "",
      click: (props: any) => {
        detail(props);

        onSetModal({
          title: t("sub_ttl_resv_cancel"),
          isOpen: true,
          styles: "w-full",
          inner: <RoomCancelResvDetail />,
        });
      },
    },
  ];

  return (
    <>
      <ListHead totalRows={pageNav?.totalRows || 0} />
      <Grid theads={theads} rowData={rowData} pageNav={pageNav} />
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_resv_no",
    type: "string",
    field: "rmResvNo",
    width: 140,
  },
  {
    langNm: "grid_rmpd_resv_dt",
    type: "date",
    field: "resvDtti",
    width: 140,
  },
  {
    langNm: "grid_resv_cnl_dt",
    type: "date",
    field: "cnlDtti",
  },
  {
    langNm: "grid_sell_dt",
    type: "date",
    field: "sellDt",
  },
  {
    langNm: "grid_rm_no",
    type: "string",
    field: "rmNo",
  },
  {
    langNm: "grid_rm_nm",
    type: "string",
    field: "rmNm",
  },
  {
    langNm: "grid_rm_typ",
    type: "string",
    field: "rmTypNm",
  },
  {
    langNm: "grid_rm_olk",
    type: "string",
    field: "rmOlkNm",
  },

  {
    langNm: "grid_lod_chl_nm",
    type: "string",
    field: "lodChlCd",
    width: 80,
  },
  {
    langNm: "grid_rmpd_nm",
    type: "string",
    field: "rmOpNm",
  },

  {
    langNm: "grid_cst_nm",
    type: "string",
    field: "resvCstNm",
  },
  {
    langNm: "grid_cst_phone",
    type: "phone",
    field: "resvCstMblNo",
  },
  {
    langNm: "grid_rmpd_amt",
    type: "price",
    field: "payAmt",
    width: 140,
  },
  {
    langNm: "grid_rmpd_cnl_amt",
    type: "price",
    field: "rmCnlFeeAmt",
    width: 140,
  },
];
